// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e8310d6","732":"64442450","977":"beecaa8e"}[chunkId] + ".chunk.js";
};